import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Preview from 'features/creative/preview/Preview'
import { useDispatch, useSelector } from 'react-redux'
import SelectBox from 'components/form/SelectBox'
import {
  reset,
  selectTalkChannel,
} from 'features/creative/add/asset/talkChannelSlice'
import ErrorText from 'components/form/ErrorText'
import classNames from 'classnames'
import { useDialog } from 'features/dialog/Dialog'
import { TalkChannelRegisterPopup } from 'features/talkChannelRegister/TalkChannelRegisterPopup'
import api from 'api/axios/foka'
import {
  inactiveAsset,
  setChannel,
} from 'features/creative/add/build/buildCreativeSlice'
import { failWithErrorResponse } from 'features/toast/Toast'
import Button from 'components/form/Button'
import NoneAnchor from 'components/NoneAnchor'

const { REACT_APP_PF_HOST } = process.env

const TalkChannel = ({ disabled, errors }) => {
  const dispatch = useDispatch()
  const { channel } = useSelector(state => state.creative.buildCreative)
  const { selectedTalkChannel } = useSelector(
    state => state.creative.assets.talkChannel
  )
  const [
    TalkChannelRegister,
    showTalkChannelRegister,
    hideTalkChannelRegister,
  ] = useDialog()
  const [
    NoChannelsAvailable,
    showNoChannelsAvailable,
    hideNoChannelsAvailable,
  ] = useDialog()

  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )

  const onSelectTalkChannel = v => dispatch(selectTalkChannel(v))
  const refreshChannel = async () => {
    try {
      const response = await api.channel.getChannelDetail(channel.id)
      dispatch(setChannel(response.data))
    } catch (e) {
      failWithErrorResponse(e?.response?.data)
    }
  }

  return (
    <>
      <TalkChannelRegister type="basic_layer" className="bizch_layer">
        <TalkChannelRegisterPopup
          bizChannelId={channel?.id}
          handleClose={() => {
            refreshChannel()
            hideTalkChannelRegister()
          }}
          handleShowNoChannelsAvailable={showNoChannelsAvailable}
        />
      </TalkChannelRegister>
      <NoChannelsAvailable type="basic_layer2" title="카카오톡 채널 등록">
        <strong className="tit_layer">카카오톡 채널 등록</strong>
        <p className="txt_layer">연동 가능한 카카오톡 채널이 없습니다.</p>
        <div className="btn_group">
          <div className="align_c">
            <a
              href={REACT_APP_PF_HOST}
              target="_blank"
              rel="noopener noreferrer"
              className="btn_gm gm_bl"
              onClick={hideNoChannelsAvailable}>
              <span className="inner_g">카카오톡 채널 만들기</span>
            </a>
          </div>
        </div>
      </NoChannelsAvailable>
      <div className="cont_material">
        <div className="group_material">
          <div className="box_material">
            <strong className="subtit_subject2">
              연동형 &gt; 톡채널
              <Button
                size="small"
                disabled={disabled}
                onClick={() => {
                  dispatch(inactiveAsset('talkChannel'))
                }}>
                삭제
              </Button>
            </strong>
            <div className="inner_material">
              <div className="material_item">
                {channel?.talkChannelAccounts.length > 0 ? (
                  <>
                    <div className="tit_itemwrap">
                      <strong className="tit_item">톡채널</strong>
                    </div>
                    <div className="desc_item">
                      <SelectBox
                        className="opt_ktalk"
                        placeholder="톡채널 선택"
                        value={selectedTalkChannel}
                        onValueChange={onSelectTalkChannel}
                        disabled={disabled}
                        error={errors?.selectedTalkChannel}>
                        {channel?.talkChannelAccounts.map(({ id, uuid }) => (
                          <SelectBox.Item key={id} value={uuid}>
                            {uuid}
                          </SelectBox.Item>
                        ))}
                      </SelectBox>
                      <ErrorText error={errors?.selectedTalkChannel} />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="add_item">
                      <p className={classNames('desc_info')}>
                        연동된 톡채널이 없습니다.
                        <br />
                        <span className="fc_emph">톡채널 연동하기</span>를
                        클릭하여 톡채널을 선택하세요.
                      </p>
                      <NoneAnchor
                        className="btn_gm gm_bl"
                        onClick={showTalkChannelRegister}>
                        <span className="inner_g">
                          <span className="img_comm ico_add" />
                          톡채널 연동하기
                        </span>
                      </NoneAnchor>
                    </div>
                    <div className="add_item">
                      <ErrorText error={errors?.talkChannels} />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <Preview type="TALK_CHANNEL" />
        </div>
      </div>
    </>
  )
}

export default TalkChannel

TalkChannel.displayName = 'TalkChannel'
TalkChannel.propTypes = {
  channel: PropTypes.object,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    talkChannels: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    selectedTalkChannel: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]),
  }),
}
